import $ from 'jquery';

jQuery(document).ready(function() {
    $('.navSearchForm__button').on('click', function(e) {
        const $form = $(this).closest('form');
        if (window.innerWidth >= 1120) {
            const $field = $form.find('.navSearchForm__field');
            if ( !$field.hasClass('visible') ) {
                e.preventDefault();
                $field.addClass('visible');
                setTimeout(() => $field.find('input').focus(), 300);
            }
        }
    });

    $(document).on('click', function() {
        const $field = $('.navSearchForm__field');
        $field.removeClass('visible');
    });

    $('.navSearchForm').on('click', function(e) {
        e.stopPropagation();
    })
});